/* eslint-disable
    import/no-mutable-exports,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {noop} from '@benchling/js-utils';
import $ from 'jquery';

import * as browser from 'lib/Browser';

interface DragDropUploadManagerAttributes {
  push: (el: HTMLElement) => void;
  pop: (el: HTMLElement) => void;
  isActive: () => boolean;
}

interface DragDropUploadAttributes extends DragDropUploadManagerAttributes {
  getManager: (
    container: HTMLElement,
    target?: Window | HTMLElement | null
  ) => DragDropUploadManagerAttributes;
}

let defaultExport: DragDropUploadAttributes;
if (!browser.isBrowser) {
  defaultExport = {
    push: noop,
    pop: noop,
    isActive() {
      return false;
    },
    getManager: (_container: HTMLElement, _target: Window | HTMLElement | null) => ({
      push: noop,
      pop: noop,
      isActive() {
        return false;
      },
    }),
  };
} else {
  const invalidFile = (e: JQueryEventObject): boolean =>
    !(e.originalEvent as DragEvent).dataTransfer?.types.includes('Files');

  // Rule of thumb: if the drag/drop event already has default prevented, a child is trying to handle the
  // drag-and-drop, so we should silently ignore the event or clean up the (dragging) state.

  function getManager(
    container: HTMLElement,
    target: Window | HTMLElement | null = null
  ): DragDropUploadManagerAttributes {
    target = target || container;
    const $target = $(target);
    const $container = $(container);

    // Return the manager if it's already been defined.
    if ($container.data('dragdrop-manager') != null) {
      return $container.data('dragdrop-manager');
    }

    // Otherwise, create a new manager and register events.
    let THE_STACK: Array<HTMLElement> = [];
    let DRAG_COLLECTION: JQuery = $();

    const manager: DragDropUploadManagerAttributes = {
      push(el: HTMLElement) {
        return THE_STACK.push(el);
      },
      pop(el: HTMLElement) {
        return (THE_STACK = THE_STACK.filter((stackEl) => stackEl !== el));
      },
      isActive() {
        return THE_STACK.length > 0;
      },
    };
    $container.data('dragdrop-manager', manager);

    $target.on('drop', (e) => {
      if (e.isDefaultPrevented()) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      if (THE_STACK.length > 0) {
        const topEl = THE_STACK[THE_STACK.length - 1];
        if (!invalidFile(e)) {
          $(topEl).trigger('filedrop', [(e.originalEvent as DragEvent).dataTransfer?.files]);
        }
        DRAG_COLLECTION = $();
      }
      $container.removeClass('dragging');
    });

    $target.on('dragover.dragdrop', (e) => {
      let effectAllowed;
      if (e.isDefaultPrevented()) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const {dataTransfer} = e.originalEvent as DragEvent;
      if (!dataTransfer) {
        return;
      }
      if (invalidFile(e) || THE_STACK.length === 0) {
        // Show no effect if dragging a non-file
        dataTransfer.dropEffect = 'none';
        return;
      }

      // IE10 and IE11 error if effectAllowed is accessed during dragover (which is fired repeatedly)
      try {
        ({effectAllowed} = dataTransfer);
        // eslint-disable-next-line benchlint/always-throw-from-catch
      } catch (error) {
        e = error;
        effectAllowed = null;
      }

      dataTransfer.dropEffect = (() => {
        switch (effectAllowed) {
          case 'move':
          case 'linkMove':
            return 'move';
          default:
            return 'copy';
        }
      })();
    });

    $target.on('dragenter.dragdrop', (e) => {
      if (e.isDefaultPrevented()) {
        DRAG_COLLECTION = $();
        $container.removeClass('dragging');
        return;
      }
      e.stopPropagation();
      const {dataTransfer} = e.originalEvent as DragEvent;
      // Not sure why, but sometimes dataTransfer is null on FF.
      // The dropEffect is optional anyways, just for visual look.
      if (dataTransfer == null) {
        return;
      }
      if (invalidFile(e) || THE_STACK.length === 0) {
        // Show no effect if dragging a non-file
        if (dataTransfer != null) {
          dataTransfer.dropEffect = 'none';
        }
        return;
      }
      // @ts-expect-error We have bad/old types for JQuery. JQuery.size() does just defer to JQuery.length
      // but it does exist on the actual object
      if (DRAG_COLLECTION.size() === 0) {
        $container.addClass('dragging');
      }
      DRAG_COLLECTION = DRAG_COLLECTION.add(e.target);
      if (dataTransfer != null) {
        dataTransfer.dropEffect = 'copy';
      }
    });

    $target.on('dragleave.dragdrop', (e) => {
      if (e.isDefaultPrevented()) {
        return;
      }
      e.stopPropagation();
      setTimeout(() => {
        DRAG_COLLECTION = DRAG_COLLECTION.not(e.target);
        // @ts-expect-error We have bad/old types for JQuery. JQuery.size() does just defer to JQuery.length
        // but it does exist on the actual object
        if (DRAG_COLLECTION.size() === 0) {
          $container.removeClass('dragging');
        }
      });
    });

    return manager;
  }

  // Setup global body/window manager.
  const DIV_LEFT = $('<div class="drop-emphasis left">');
  const DIV_TOP = $('<div class="drop-emphasis top">');
  const DIV_RIGHT = $('<div class="drop-emphasis right">');
  const DIV_BOTTOM = $('<div class="drop-emphasis bottom">');
  $('body').append(DIV_LEFT).append(DIV_TOP).append(DIV_RIGHT).append(DIV_BOTTOM);

  const windowManager = getManager(document.body, window);

  defaultExport = {
    push: windowManager.push,
    pop: windowManager.pop,
    getManager,
    isActive: windowManager.isActive,
  };
}
export default defaultExport;
